const STORAGE_KEY = "feedback-form-state";
const form = document.querySelector(".feedback-form");
let formData = { email: "", message: "" };

const savedData = localStorage.getItem(STORAGE_KEY);
if (savedData) {
    formData = JSON.parse(savedData);
    form.elements.email.value = formData.email;
    form.elements.message.value = formData.message;
}

form.addEventListener("input", e => {
    formData[e.target.name] = e.target.value.trim();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(formData));
});

form.addEventListener("submit", e => {
    e.preventDefault();
    if (formData.email === "" || formData.message === "") {
        return alert("Fill please all fields");
    }
    console.log(formData);
    localStorage.removeItem(STORAGE_KEY);
    form.reset();
    formData = { email: "", message: "" };
});